import Accordion from "../../../ui-component/extended/Accordion";
import OrdersDetailsCard from "../../../ui-component/cards/OrdersDetailsCard";
import React, {useEffect, useState} from "react";
import requestToServer from "../../../utils/requersToServer";
import {getUserId} from "../../../utils/checkUserId";
import convertStatus from "../../../utils/convertStatus";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import SkeletonTotalIncomeCard from "../../../ui-component/cards/Skeleton/TotalIncomeCard";
import {FormattedMessage, useIntl} from "react-intl";
import TagGenerator from "../../../utils/TagGenerator";
import notFoundImg from "../../../assets/images/notFound.png";
import {LazyLoadImage} from "react-lazy-load-image-component";
import Card from "@material-ui/core/Card";

const OrdersPage = ({rowsHorizontal = 2}) => {
  const intl = useIntl()

  const [loadOrders, setLoadOrders] = useState(false);
  const [orders, setOrders] = useState([]);

  const getOrders = async (first = false) => {
    first && setLoadOrders(true);

    requestToServer('GetOrdersAll', {userId: await getUserId()}).then(
      result => {
        const {getOrdersAll} = result

        if (getOrdersAll) {
          const updateOrders = [];
          getOrdersAll.map((order, key) => updateOrders.push({
            id: `order-${order.orderId}`,
            defaultExpand: key === 0,
            title: `${intl.formatMessage({ id: "order-text" })} #${order.orderId}`,
            status: convertStatus(order.status),
            content:
              <OrdersDetailsCard
                products={order.products}
                rowsHorizontal={rowsHorizontal}
              />
          }));
          setOrders(updateOrders);

          setLoadOrders(false);
        }
      }).catch(err => console.error(err))
  }

  useEffect(() => {
    //витягую всі закази
    getOrders(true);

    setInterval(() => getOrders(), 10000)
  }, []);

  return (
    <div>

      <TagGenerator page={'orders'}/>

      {
        (loadOrders) ?
          (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SkeletonTotalIncomeCard />
              </Grid>
              <Grid item xs={12}>
                <SkeletonTotalIncomeCard />
              </Grid>
              <Grid item xs={12}>
                <SkeletonTotalIncomeCard />
              </Grid>
            </Grid>
          ) :
          (orders.length) ?
            <Accordion data={orders}/> :
            <Card style={{textAlign: 'center', padding: 25}}>
                <LazyLoadImage
                  src={notFoundImg}
                  effect={'blur'}
                  height={320}
                />
                <p style={{fontSize: 18, textTransform: 'uppercase'}}>
                  <FormattedMessage id={'orders-not-found'} />
                </p>
            </Card>
      }

      <Button variant="contained" href={'/'} style={{width: '100%', margin: '25px 0px'}}>
        <FormattedMessage id="btn-new-order" />
      </Button>

    </div>
  )
}

export default OrdersPage
